
import { inputGroupNames } from "constants/inputGroupNames"
import { GetAdressFromCEP } from "services/CallAPIs"
export function resultsAreValid(results)
{
    if (results === null | results === undefined) { return false }

    return results.status !== 500
}

export function dropdownsAreValid() { return dropdownsWithDefaultValue().length === 0 }

export function dropdownsWithDefaultValue()
{
    let dropdownsWithDefaultValue = []
    const dropdownElements = document.getElementsByTagName("select")
    for (let i = 0 ; i <= dropdownElements.length - 1 ; i += 1)
    {
        if (dropdownElements[i].value === dropdownElements[i].options[0].value) { dropdownsWithDefaultValue.push(dropdownElements[i]) }
    }

    return dropdownsWithDefaultValue
}

export function getFormData(form)
{
    const data = new FormData(form) // pega todos os inputs com propriedade "name" única dentro de <Form>

    return Object.fromEntries(data.entries())
}

export function autoFill(formData, readOnly, camposNaoEditaveis)
{

    const docData =
    {
        numDoc: formData?.numDoc,
        ...formData.areas,
        ...formData.caracteristicasImovel,
        ...formData.contratada,
        ...formData.contratante,
        ...formData.conclusao,
        ...formData.corpo,
        ...formData.dadosCartoriais,
        ...formData.dadosImovel,
        ...formData.dadosObra,
        ...formData.dadosObraInfra,
        ...formData.dadosServico,
        ...formData.descConfront,
        ...formData.detalhesGuia?.taxInputs,
        ...formData.detalhesMulta,
        ...formData.enderecoProprietario,
        ...formData.enderecoObra,
        ...formData.especificAutorizacao,
        ...formData.especificEmpreendimento,
        ...formData.finalidade,
        ...formData.memorialDescritivo,
        ...formData.notas,
        ...formData.proprietario,
        // ...formData.registroProcessosImovel, // TODO passar para o back de forma recuperável
        ...formData.representante,
        ...formData.requerente,
        ...formData.servicosASeremRealizados,
        ...formData.usoOcupSolo,
        ...formData.vagasEstac
    }

    if (!formData.requerente)
    {
        docData["nomeRequerente"] = formData?.proprietario?.nomeProprietario
        docData["cpfCnpjRequerente"] = formData?.proprietario?.cpfCnpjProprietario
    }

    if (formData.servicosASeremRealizados)
    {
        docData["servicosASeremRealizados0"] = formData.servicosASeremRealizados?.servico[0]
    }

    docData["numElevadores"] = Number(formData?.especificEmpreendimento?.numElevadoresPlataformas.split("|")[0])
    docData["numeroPlataformas"] = Number(formData?.especificEmpreendimento?.numElevadoresPlataformas.split("|")[1])

    docData["registroAutRepGerais"] = formData?.registroProcessosImovel?.registroProcessosImovel.split(",")[0].replace("Autorização para Instalação de Estação de Rádio-Base n° ", "")
    docData["registroProcesso"] = formData?.registroProcessosImovel?.registroProcessosImovel.split(",")[1].replace(" obtida no Processo n° ", "")

    docData["areaLotes"] = formData?.especificEmpreendimento?.areaLotesMetros
    docData["areaVerde"] = formData?.especificEmpreendimento?.areaVerdeID
    docData["sistViario"] = formData?.especificEmpreendimento?.sistViarioID
    
    formData?.areasLotes?.areas.forEach( (area, index) => {
        formData["nome" + inputGroupNames.AreasLotes + index] = area.nomeArea
        formData["area" + inputGroupNames.AreasLotes + index] = area.area
    })

    formData?.areasVerdes?.areas.forEach( (area, index) => {
        formData["nome" + inputGroupNames.AreasVerdes + index] = area.nomeArea
        formData["area" + inputGroupNames.AreasVerdes + index] = area.area
    })

    formData?.areasSistViario?.areas.forEach( (area, index) => {
        formData["nome" + inputGroupNames.AreasSistViario + index] = area.nomeArea
        formData["area" + inputGroupNames.AreasSistViario + index] = area.area
    })

    formData?.detalhesMulta?.docsOrigemMulta.forEach( (docOrigem, index) => {
        formData[inputGroupNames.DocsOrigemMulta + index] = docOrigem.docOrigemMulta
        formData["numDocOrigem" + inputGroupNames.DocsOrigemMulta + index] = docOrigem.numDocOrigem
        formData["anoDocOrigem" + inputGroupNames.DocsOrigemMulta + index] = docOrigem.anoDocOrigem
    })
    
    formData?.descConfront?.areasDemarcadas.filter(text => text.trim() !== "").forEach( (area, index) => {
        formData["loteNomeAreaDemarcada" + index] = area.split(":")[0]
        formData["loteDescricaoAreaDemarcada" + index] = area.split(":")[1]
    })
    
    formData?.descConfront?.areasDesmembradas.filter(text => text.trim() !== "").forEach( (area, index) => {
        formData["loteNomeAreaDesmembrada" + index] = area.split(":")[0]
        formData["loteDescricaoAreaDesmembrada" + index] = area.split(":")[1]
    })
    
    formData?.descConfront?.areasRemembradas.filter(text => text.trim() !== "").forEach( (area, index) => {
        formData["loteNomeAreaRemembrada" + index] = area.split(":")[0]
        formData["loteDescricaoAreaRemembrada" + index] = area.split(":")[1]
    })
    
    formData?.especificAutorizacao?.registros?.filter(text => text.trim() !== "").forEach( (registro, index) => {
        formData["numeroregistrosMatriculas" + index] = registro.split(":")[0]
        formData["descricaoregistrosMatriculas" + index] = registro.split(":")[1]
    })

    formData?.obs?.observacoes.forEach( (obs, index) => {
        formData["obs" + index] = obs[0]
    })
 
    formData?.pavimentos?.pavimentos.forEach( (pav, index) => {
        formData["pavimentosQuantidade" + index] = pav.qtd
        formData["pavimentosClassificacao" + index] = pav.classificacao
        formData["pavimentosAreaConstruida" + index] = pav.areaConstruida.replace(" m²", "")
        formData["pavimentosDetAreaConstruida" + index] = pav.detAreaConstruida
        formData["pavimentosDescricaoAmbientes" + index] = pav.especificacoes
    })
    
    formData?.respTecs?.respTecs.forEach( (respTec, index) => {
        formData["tipoRespTec" + index] = respTec.tipo
        formData["nomeRespTec" + index] = respTec.nome
        formData["crea_cauRespTec" + index] = respTec.creaCau
    })
    
    formData?.unidHabit?.unidsHabitacionais.forEach( (unidHab, index) => {
        formData["tipounidadesHabitacionais" + index] = unidHab.tipo
        formData["qtdunidadesHabitacionais" + index] = unidHab.qtd
        formData["areaUtilunidadesHabitacionais" + index] = unidHab.areaUtil.replace(" m²", "")
        formData["areaConstruidaunidadesHabitacionais" + index] = unidHab.areaConstruida.replace(" m²", "")
        formData["areaPrivativaunidadesHabitacionais" + index] = unidHab.areaPrivativa.replace(" m²", "")
    })

    for (var topLevelKey in formData)
    {
        const value = formData[topLevelKey]
        if (typeof value !== 'object' && !Array.isArray(value) && value !== null)
            docData[topLevelKey] = value
    }

    const inputFields = document.getElementsByTagName("input")
    const dropdownFields = document.getElementsByTagName("select")
    const textAreaFields = document.getElementsByTagName("textArea")

    function isNotNan(x) { return x === x}
// console.log(Object.keys(camposNaoEditaveis));

    for (let i = 0 ; i <= inputFields.length - 1 ; i += 1)
    {
        const inputName = inputFields[i].name
        if (docData[inputName] !== undefined && docData[inputName] !== null && isNotNan(docData[inputName]))
        {
            const campoNaoEditavel =  camposNaoEditaveis ? Object.keys(camposNaoEditaveis).includes(inputName) : false
            inputFields[i].value = docData[inputName]
            inputFields[i].readOnly = campoNaoEditavel ? true : readOnly
            if (campoNaoEditavel ? true : readOnly)
            {
                inputFields[i].className += " bg-secondary opacity-75"
            }
        }
    }

    for (let i = 0 ; i <= dropdownFields.length - 1 ; i += 1)
    {
        const dpName = dropdownFields[i].name
        if (docData[dpName] !== undefined && docData[dpName] !== null && isNotNan(docData[dpName]))
        {
            dropdownFields[i].value = docData[dpName]
            dropdownFields[i].readOnly = readOnly
        }
    }

    for (let i = 0 ; i <= textAreaFields.length - 1 ; i += 1)
    {
        const textAreaName = textAreaFields[i].name
        if (docData[textAreaName] !== undefined && docData[textAreaName] !== null && isNotNan(docData[textAreaName]))
        {
            textAreaFields[i].value = docData[textAreaName]
            textAreaFields[i].readOnly = readOnly
        }
    }

}

export async function AutoCompleteAddress(cepFieldName, bairroFieldName, complementoFieldName, enderecoFieldName)
{

    const cep = document.getElementsByName(cepFieldName)[0].value
    const result = await GetAdressFromCEP(cep)
    
    if (result.hasOwnProperty("erro"))
    {
        alert("Cep nao encontrado")
    }
    else
    {
        document.getElementsByName(bairroFieldName)[0].value = result.bairro || ""
        document.getElementsByName(complementoFieldName)[0].value = result.complemento || ""
        document.getElementsByName(enderecoFieldName)[0].value = result.logradouro || ""
    }
    
}

export async function autoCompleteEndereco()
{
    return await AutoCompleteAddress("cepProprietario", "bairroProprietario", "complementoProprietario", "logradouroProprietario")
}

export function autoCompleteAeroporto()
{
    const inputZoneamentoAeronautica = document.getElementsByName("zoneamentoAeroporto")[0]
    const inputZonaProtecao = document.getElementsByName("zonaProtecao")[0]
    const inputZonaRuido = document.getElementsByName("zonaRuido")[0]

    if (inputZoneamentoAeronautica.value === "-")
    {
        inputZonaProtecao.value = inputZonaProtecao.options[1].value
        inputZonaRuido.value = inputZonaRuido.options[1].value
    }
    else
    {
        inputZonaProtecao.value = inputZonaProtecao.options[0].value
        inputZonaRuido.value = inputZonaRuido.options[0].value
    }

}

export function formatDate(dateStr)
{
    const data = new Date(dateStr)
    data.setUTCHours(data.getUTCHours() - 3)
    // Obter componentes da data
    const day = String(data.getUTCDate()).padStart(2, '0');
    const month = String(data.getUTCMonth() + 1).padStart(2, '0'); // Janeiro é 0
    const year = data.getUTCFullYear();

    const hours = String(data.getUTCHours()).padStart(2, '0');
    const minutes = String(data.getUTCMinutes()).padStart(2, '0');
    const seconds = String(data.getUTCSeconds()).padStart(2, '0');

    // Formatar a data no formato dia/mês/ano - hora:minuto:segundo
    const formattedDate = `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
    return formattedDate
}

export function isDateTimeFormat(possibleDateTime)
{
    const regexDateTime = /([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2}).([0-9]*)Z/
    return typeof(possibleDateTime) === "string" && possibleDateTime.match(regexDateTime) != undefined
}

export function fillInputWithCache()
{
    const inputFields = document.getElementsByTagName("input")
    const dropdownFields = document.getElementsByTagName("select")
    const textAreaFields = document.getElementsByTagName("textArea")

    // console.log(inputFields.length)
    for (let i = 0 ; i <= inputFields.length - 1 ; i += 1)
    {
        const inputName = inputFields[i].name
        inputFields[i].value = localStorage.getItem("DocInput-" + inputName)
    }

    for (let i = 0 ; i <= dropdownFields.length - 1 ; i += 1)
    {
        const dpName = dropdownFields[i].name
        dropdownFields[i].value = localStorage.getItem("DocInput-" + dpName)
    }

    for (let i = 0 ; i <= textAreaFields.length - 1 ; i += 1)
    {
        const textAreaName = textAreaFields[i].name
        textAreaFields[i].value = localStorage.getItem("DocInput-" + textAreaName)
    }
}


export function NumberValidation(value, min, max)
{
    if (value < min ) { return "valor inferior ao mínimo permitido (" + min + ")" }
    if (max < value) { return "valor superior ao máximo permitido (" + max + ")"}
    return
}

// export function CountItemsInListFields(inputFields, listName)
// {
//     return CountItemsInGroupFields(inputFields, listName)
// }

export function saveInputInCache(tipoDoc, suTipoDoc, setShowAlertDataSaved)
{
    const inputFields = document.getElementsByTagName("input")
    const dropdownFields = document.getElementsByTagName("select")
    const textAreaFields = document.getElementsByTagName("textArea")

    for (let i = 0 ; i <= inputFields.length - 1 ; i += 1)
    {
        const inputName = inputFields[i].name
        localStorage.setItem("DocInput-" + inputName, inputFields[i].value)
    }

    for (let i = 0 ; i <= dropdownFields.length - 1 ; i += 1)
    {
        const dpName = dropdownFields[i].name
        localStorage.setItem("DocInput-" + dpName, dropdownFields[i].value)
    }

    for (let i = 0 ; i <= textAreaFields.length - 1 ; i += 1)
    {
        const textAreaName = textAreaFields[i].name
        localStorage.setItem("DocInput-" + textAreaName, textAreaFields[i].value)
    }

    localStorage.setItem("TipoDocSaved-", tipoDoc)
    localStorage.setItem("SubTipoDocSaved-", suTipoDoc)
    setShowAlertDataSaved(true)
}
